import { For, Icon, If, onMount, reactive, watch } from 'cdui-js';
import { lastProcess, nextProcess, pState, setFormValidateFunc } from '../../store';
import { busConfigs, busConfigsTick } from '../../../../../../stores/bus-config';
import { saveAccount } from '../../../../../../api/open-account';
import { LastNextBtns } from '../../components/LastNextBtns';
import { isOpenProgressReEdit } from '../../reEditMode';
import { showToast } from '../../../../components/Toast';
import i18n from '../../../../../../i18n';

const IconMap = {
  HKD: () => (
    <svg width="40" height="40" viewBox="0 0 40 40" stroke="none" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_276_694)">
        <rect width="40" height="40" rx="8" fill="#DE2910" />
        <path
          d="M0 20C0 25.3043 2.10714 30.3914 5.85786 34.1421C9.60859 37.8929 14.6957 40 20 40C25.3043 40 30.3914 37.8929 34.1421 34.1421C37.8929 30.3914 40 25.3043 40 20C40 14.6957 37.8929 9.60859 34.1421 5.85786C30.3914 2.10714 25.3043 0 20 0C14.6957 0 9.60859 2.10714 5.85786 5.85786C2.10714 9.60859 0 14.6957 0 20Z"
          fill="#DE2910"
        />
        <path
          d="M18.9999 20.1286C18.0443 19.4355 17.4005 18.3937 17.2079 17.2291C17.0154 16.0645 17.2896 14.8709 17.9713 13.9071C17.9864 13.8853 18.0096 13.8705 18.0358 13.8658C18.0619 13.8611 18.0888 13.867 18.1106 13.8821C18.1324 13.8973 18.1472 13.9205 18.1519 13.9466C18.1566 13.9727 18.1507 13.9996 18.1356 14.0214C17.4907 14.9275 17.2233 16.0489 17.3899 17.1485C17.5565 18.2481 18.1441 19.2399 19.0284 19.9143C18.6187 19.471 18.3916 18.8893 18.3927 18.2857C18.3706 17.8449 18.4778 17.4072 18.7012 17.0265C18.9245 16.6458 19.2543 16.3386 19.6499 16.1428C20.2266 15.9026 20.7269 15.5096 21.0969 15.0061C21.467 14.5027 21.6927 13.9079 21.7499 13.2857C21.7477 12.75 21.6022 12.2247 21.3284 11.7643C21.2808 11.6833 21.2284 11.6048 21.1713 11.5286C21.03 11.2671 20.9447 10.9791 20.9207 10.6828C20.8968 10.3866 20.9347 10.0886 21.0321 9.80779C21.1295 9.52699 21.2843 9.26953 21.4865 9.05177C21.6888 8.834 21.9342 8.66069 22.207 8.54285H21.9784C18.0141 8.54285 15.3213 11.4 15.3213 14.7143C15.321 15.8815 15.6716 17.0219 16.3275 17.9874C16.9835 18.9529 17.9146 19.6989 18.9999 20.1286ZM18.2856 12.9857V12.2714L18.8427 12.7071L19.5141 12.4928L19.2713 13.1571L19.6856 13.7286H18.9713L18.5499 14.3L18.3499 13.5857L17.6784 13.3643L18.2856 12.9857Z"
          fill="white"
        />
        <path
          d="M12.8072 22.35C13.9254 22.7176 15.1288 22.7376 16.2587 22.4073C17.3885 22.0771 18.3916 21.4121 19.1358 20.5C18.194 21.2141 17.0085 21.5276 15.8368 21.3724C14.6652 21.2173 13.6021 20.606 12.8787 19.6714C12.8661 19.6504 12.8617 19.6256 12.8662 19.6015C12.8708 19.5775 12.884 19.5559 12.9033 19.541C12.9227 19.526 12.9469 19.5187 12.9713 19.5203C12.9957 19.522 13.0186 19.5326 13.0358 19.55C13.7033 20.4112 14.6738 20.9858 15.7499 21.157C16.826 21.3282 17.9269 21.083 18.8287 20.4714C18.2949 20.7015 17.6957 20.7294 17.1429 20.55C16.7218 20.4319 16.3439 20.1943 16.0549 19.866C15.7659 19.5377 15.5781 19.1327 15.5144 18.7C15.4591 18.0802 15.2366 17.487 14.8705 16.9838C14.5044 16.4806 14.0085 16.0862 13.4358 15.8429C12.9305 15.6786 12.3907 15.6515 11.8715 15.7643L11.6001 15.8357C11.3076 15.8896 11.0072 15.8819 10.7178 15.8134C10.4285 15.7448 10.1566 15.6167 9.91945 15.4373C9.68229 15.2579 9.48506 15.0312 9.34031 14.7714C9.19555 14.5117 9.10645 14.2246 9.07865 13.9286L9.00008 14.1429C7.75722 17.8786 9.62865 21.3143 12.8072 22.35ZM11.9858 18.4V17.6857L12.5429 18.1214L13.2144 17.9072L12.9715 18.5714L13.3858 19.1429H12.6715L12.2501 19.7143L12.0501 19L11.3787 18.7786L11.9858 18.4Z"
          fill="white"
        />
        <path
          d="M18.936 24.5429C18.4153 25.3131 17.6657 25.9003 16.7931 26.2214C16.772 26.2156 16.7533 26.2031 16.7401 26.1856C16.7268 26.1682 16.7196 26.1469 16.7196 26.125C16.7196 26.1031 16.7268 26.0818 16.7401 26.0644C16.7533 26.047 16.772 26.0344 16.7931 26.0286C17.8105 25.6625 18.6519 24.9253 19.1487 23.965C19.6454 23.0046 19.7608 21.8919 19.4717 20.85C19.5142 21.4152 19.3547 21.9771 19.0217 22.4357C18.7783 22.799 18.435 23.084 18.0332 23.2564C17.6314 23.4288 17.1883 23.4811 16.7574 23.4072C16.1477 23.2621 15.5099 23.2866 14.9132 23.478C14.3164 23.6694 13.7833 24.0203 13.3717 24.4929C13.0653 24.9128 12.8734 25.405 12.8145 25.9214V26.2072C12.7752 26.5018 12.6749 26.785 12.5202 27.0388C12.3655 27.2926 12.1597 27.5114 11.9158 27.6814C11.672 27.8513 11.3954 27.9687 11.1038 28.026C10.8121 28.0833 10.5117 28.0793 10.2217 28.0143L10.4003 28.15C13.6074 30.4786 17.4503 29.7714 19.4145 27.0714C20.1122 26.1174 20.503 24.9736 20.5349 23.7921C20.5668 22.6106 20.2383 21.4474 19.5931 20.4572C19.8209 21.1407 19.88 21.8692 19.7656 22.5806C19.6512 23.292 19.3666 23.9652 18.936 24.5429ZM15.9003 26.7643L15.4788 27.3357L15.2788 26.6214L14.6074 26.4L15.1931 26V25.2857L15.7503 25.7214L16.4217 25.5072L16.1788 26.1714L16.5931 26.7429L15.9003 26.7643Z"
          fill="white"
        />
        <path
          d="M19.6211 20.2072C20.8024 20.1841 21.9451 20.6279 22.801 21.4424C23.657 22.2569 24.157 23.3762 24.1925 24.5572C24.1925 24.5837 24.182 24.6091 24.1632 24.6279C24.1445 24.6466 24.119 24.6572 24.0925 24.6572C24.066 24.6572 24.0406 24.6466 24.0218 24.6279C24.0031 24.6091 23.9925 24.5837 23.9925 24.5572C23.9594 23.4768 23.5192 22.4488 22.7602 21.6793C22.0012 20.9097 20.9795 20.4553 19.8997 20.4072C20.4726 20.5291 20.9809 20.857 21.3282 21.3286C21.5999 21.6722 21.7661 22.0872 21.8067 22.5233C21.8472 22.9594 21.7604 23.398 21.5568 23.7857C21.2294 24.3238 21.0563 24.9416 21.0563 25.5715C21.0563 26.2013 21.2294 26.8191 21.5568 27.3572C21.8693 27.7883 22.2908 28.1285 22.7782 28.3429L23.0425 28.4429C23.3115 28.5709 23.5508 28.7537 23.7451 28.9794C23.9395 29.2051 24.0847 29.4689 24.1714 29.7539C24.2581 30.0389 24.2844 30.3388 24.2487 30.6345C24.213 30.9303 24.116 31.2153 23.964 31.4715L24.1497 31.3429C27.3568 29.0143 27.8711 25.1357 25.914 22.4357C25.2203 21.4637 24.2444 20.7285 23.1187 20.3298C21.993 19.9311 20.7719 19.8883 19.6211 20.2072ZM24.1782 26.1072L23.7568 26.6786L23.5568 25.9643L22.8854 25.7429L23.4711 25.3429V24.6286L24.0282 25.0643L24.6997 24.85L24.4568 25.5143L24.8711 26.0857L24.1782 26.1072Z"
          fill="white"
        />
        <path
          d="M31.3282 19.1786C30.0997 15.4071 26.5782 13.7214 23.3997 14.75C22.2832 15.1091 21.3013 15.7969 20.5825 16.7235C19.8636 17.6501 19.4414 18.7722 19.3711 19.9429C19.7209 18.8213 20.4967 17.8818 21.5319 17.3261C22.567 16.7705 23.7788 16.6431 24.9068 16.9714C24.9195 16.9752 24.9313 16.9814 24.9415 16.9897C24.9518 16.998 24.9603 17.0083 24.9666 17.0199C24.9729 17.0315 24.9769 17.0442 24.9783 17.0574C24.9796 17.0705 24.9784 17.0838 24.9747 17.0964C24.9709 17.1091 24.9647 17.1209 24.9564 17.1312C24.9481 17.1414 24.9378 17.1499 24.9262 17.1562C24.9146 17.1625 24.9019 17.1665 24.8887 17.1679C24.8756 17.1693 24.8623 17.168 24.8497 17.1643C23.7972 16.8574 22.6671 16.9655 21.6918 17.4664C20.7166 17.9673 19.9704 18.8229 19.6068 19.8571C19.9023 19.338 20.3813 18.9482 20.9497 18.7643C21.3604 18.6123 21.8064 18.5826 22.2337 18.679C22.6609 18.7754 23.0511 18.9935 23.3568 19.3071C23.7646 19.7835 24.2951 20.1392 24.8906 20.3356C25.4862 20.5321 26.1242 20.5617 26.7354 20.4214C27.2418 20.2574 27.6954 19.9615 28.0497 19.5643L28.2282 19.3429C28.4335 19.1271 28.6814 18.9564 28.9563 18.8418C29.2311 18.7272 29.5268 18.6711 29.8246 18.6771C30.1223 18.6832 30.4155 18.7512 30.6855 18.8769C30.9554 19.0026 31.1962 19.1832 31.3925 19.4071C31.3282 19.3214 31.3282 19.25 31.3282 19.1786ZM26.0925 18.0214L25.6711 18.5929L25.4711 17.8786L24.7997 17.6571L25.3854 17.2571V16.5429L25.9425 16.9786L26.6139 16.7643L26.3711 17.4286L26.7854 18L26.0925 18.0214Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_276_694">
          <rect width="40" height="40" rx="8" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  USD: () => (
    <svg width="40" height="40" viewBox="0 0 40 40" stroke="none" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_278_711)">
        <path
          d="M0 20C0 25.3043 2.10714 30.3914 5.85786 34.1421C9.60859 37.8929 14.6957 40 20 40C25.3043 40 30.3914 37.8929 34.1421 34.1421C37.8929 30.3914 40 25.3043 40 20C40 14.6957 37.8929 9.60859 34.1421 5.85786C30.3914 2.10714 25.3043 0 20 0C14.6957 0 9.60859 2.10714 5.85786 5.85786C2.10714 9.60859 0 14.6957 0 20Z"
          fill="#DE2910"
        />
        <path
          d="M5.71429 0H34.2857C38.0952 0 40 1.90476 40 5.71429V34.2857C40 38.0952 38.0952 40 34.2857 40H5.71429C1.90476 40 0 38.0952 0 34.2857V5.71429C0 1.90476 1.90476 0 5.71429 0Z"
          fill="#FF3A3A"
        />
        <path
          d="M0 34.2856C0 34.5313 0.0428571 34.7627 0.0714285 34.9999H39.9286C39.9571 34.7627 40 34.5313 40 34.2856V31.4999H0V34.2856ZM24.2029 9.49988H40V5.99988H24.2029V9.49988ZM24.2 26.4856H24V26.4999H40V22.9999H24.2V26.4856ZM24.2029 17.9999H40V14.4999H24.2029V17.9999Z"
          fill="#F9F9F9"
        />
        <path
          d="M24.2 0H5.71429C4.19876 0 2.74531 0.602039 1.67368 1.67368C0.602039 2.74531 0 4.19876 0 5.71429V26.4886H24.2V0Z"
          fill="#2024C1"
        />
        <path
          d="M7.50098 11.0601L5.64669 12.003L6.00098 10.0087L4.50098 8.60012L6.5724 8.31441L7.50098 6.50012L8.42955 8.31155L10.501 8.60012L9.00098 10.0087L9.35526 12.0001L7.50098 11.0601ZM16.501 11.0601L14.6438 12.003L15.001 10.0087L13.501 8.60012L15.5753 8.31441L16.501 6.50012L17.4295 8.31155L19.501 8.60012L18.001 10.0087L18.3553 12.0001L16.501 11.0601ZM7.50098 18.0601L5.64669 19.003L6.00098 17.0087L4.50098 15.6001L6.5724 15.3144L7.50098 13.5001L8.42955 15.3116L10.501 15.6001L9.00098 17.0087L9.35526 19.0001L7.50098 18.0601ZM16.501 18.0601L14.6438 19.003L15.001 17.0087L13.501 15.6001L15.5753 15.3144L16.501 13.5001L17.4295 15.3116L19.501 15.6001L18.001 17.0087L18.3553 19.0001L16.501 18.0601Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_278_711">
          <rect width="40" height="40" rx="8" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
};

export const SelectCurrency = (props) => {
  const buildList = () =>
    (busConfigs.depositCurrency || []).map((item) => {
      return {
        icon: IconMap[item.value],
        label: item.label,
        value: item.value,
      };
    });

  const state = reactive({
    list: buildList(),
    loading: false,
  });

  const validateFunc = async () => {
    if (!pState.currency.accountType) {
      showToast(i18n.OpenProgress.Transfer.Currency.ToastRequired);
      return false;
    }
    return true;
  };

  watch(
    () => busConfigsTick.v,
    () => {
      state.list = buildList();
    },
  );

  onMount(() => {
    if (!isOpenProgressReEdit(props)) {
      setFormValidateFunc({ callback: validateFunc });
    }
  });

  return (
    <div class="padding-x-L margin-y-XXL">
      <div class="font-s-L font-bold color-D margin-b-L">{i18n.OpenProgress.Transfer.Currency.Title}</div>

      <div>
        <For each={state.list}>
          {(item) => (
            <div
              style={{
                border:
                  pState.currency.accountType === item.value
                    ? '1px solid var(--text-1)'
                    : '1px solid var(--check-border)',
              }}
              class="round padding-XL flex align-center justify-space-between margin-b"
              onclick={() => {
                pState.currency.accountType = item.value;
                // 下一页「币种类型」与存入币种同值（HKD / USD）
                pState.bank.bankAccountType = item.value;
              }}
            >
              <div class="flex align-center gap-12px">
                <item.icon />
                <div>{item.label}</div>
              </div>

              <Icon name="common-arrow-right"></Icon>
            </div>
          )}
        </For>
      </div>

      {/* 修改资料流程由 EditErrorInfo 底部「下一步」统一保存并推进 */}
      <If when={!isOpenProgressReEdit(props)}>
        <LastNextBtns
          loading={state.loading}
          last={() => {
            lastProcess();
          }}
          next={async () => {
            try {
              state.loading = true;
              await saveAccount({
                accountType: pState.currency.accountType,
                progress: 18,
              });
              nextProcess();
            } finally {
              state.loading = false;
            }
          }}
        />
      </If>
    </div>
  );
};
